import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { Actions, ofActionSuccessful } from '@ngxs/store';

import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { CancelCourtBookingSuccessAction } from '../../+store/court-event-modals.actions';
import { CourtEventModalsFacade } from '../../+store/court-event-modals.facade';

@Component({
    selector: 'app-court-booking-cancel-reason-modal',
    templateUrl: './court-booking-cancel-reason-modal.component.html',
    styleUrls: ['./court-booking-cancel-reason-modal.component.scss'],
    standalone: false
})
export class CourtBookingCancelReasonModalComponent implements OnInit {
    form: UntypedFormGroup;
    isLoading$ = this.courtEventModalsFacade.isCancelFormLoading$;
    isFormValid$ = this.courtEventModalsFacade.isCancelFormValid$;

    public courtBookingId: string;

    private subscriptions: Subscription = new Subscription();
    constructor(
        public bsModalRef: BsModalRef,
        private formBuilder: UntypedFormBuilder,
        private courtEventModalsFacade: CourtEventModalsFacade,
        private actions$: Actions
    ) { }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            reason: [null, [Validators.required]]
        });

        this.subscriptions.add(
            this.actions$.pipe(ofActionSuccessful(CancelCourtBookingSuccessAction)).subscribe(() => {
                this.bsModalRef.hide();
            })
        );
    }
    onSave(): void {
        this.courtEventModalsFacade.cancelCourtBooking(this.courtBookingId);
    }
}
